module.exports = __webpack_public_path__ + "static/img/decorate.10bd2f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/decorate.png
// module id = VGNY
// module chunks = 1